export function LogoWrapper({ src, noBG = false, cover = false}: { src: string, noBG?: boolean, cover?: boolean}) {
  return (
    <img
      className={`h-14 w-full object-contain p-1 ${noBG !== true && 'bg-white'} rounded grayscale hover:grayscale-0 transition duration-300`}
      src={src}
      alt={src}
    />
  );
}
